// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../../../../resources/images/spinner.svg";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tS6p8g\\+HxnwrWK.qRhO-uKhpO\\+Uh2.D4Luyrrm4aDhLs {\n  text-align: center;\n}\n.tS6p8g\\+HxnwrWK.qRhO-uKhpO\\+Uh2 > .JzsjRTdQ87NvvF {\n  margin: 0 auto;\n}\n.tS6p8g\\+HxnwrWK.D4Luyrrm4aDhLs > .JzsjRTdQ87NvvF {\n  display: inline-block;\n  vertical-align: middle;\n}\n.JzsjRTdQ87NvvF {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-size: 30px 30px;\n  display: block;\n  height: 30px;\n  width: 30px;\n}\n.JzsjRTdQ87NvvF.\\-4ajUFCbHGrqux {\n  background-size: 18px 18px;\n  height: 18px;\n  width: 18px;\n}\n.JzsjRTdQ87NvvF.dg7g1sFO51SJQF {\n  margin-right: 3px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "tS6p8g+HxnwrWK",
	"centered": "qRhO-uKhpO+Uh2",
	"inline": "D4Luyrrm4aDhLs",
	"spinner": "JzsjRTdQ87NvvF",
	"small": "-4ajUFCbHGrqux",
	"modLeft": "dg7g1sFO51SJQF"
};
export default ___CSS_LOADER_EXPORT___;
